import { render, staticRenderFns } from "./AddCardMobile.vue?vue&type=template&id=642c8ea4&scoped=true&"
import script from "./AddCardMobile.vue?vue&type=script&lang=js&"
export * from "./AddCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./AddCardMobile.vue?vue&type=style&index=0&id=642c8ea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c8ea4",
  null
  
)

export default component.exports